import type { HTMLAttributes } from 'react';

import { Container, LayerFour, LayerOne, LayerThree, LayerTwo } from './styles';

interface HamburgerMenuProps {
  onClick: Required<HTMLAttributes<HTMLAnchorElement>>['onClick'];

  isActive: boolean;

  /**
   * @default false
   */
  isWhite?: boolean;

  aligned?: 'left' | 'right';
}

const HamburgerMenu = ({ onClick, isActive, isWhite = false, aligned = 'right' }: HamburgerMenuProps) => {
  return (
    <Container
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
      href="#"
      role="button"
      aria-label="Menu"
      aria-expanded={isActive}
    >
      <LayerOne isActive={isActive} isWhite={isWhite} aligned={aligned} data-testid="layerOne" />
      <LayerTwo isActive={isActive} isWhite={isWhite} aligned={aligned} data-testid="layerTwo" />
      <LayerThree isActive={isActive} isWhite={isWhite} aligned={aligned} data-testid="layerThree" />
      <LayerFour isActive={isActive} isWhite={isWhite} aligned={aligned} data-testid="layerFour" />
    </Container>
  );
};

export default HamburgerMenu;
